import { Modal, ModalBody, ModalContent, ModalOverlay } from './style';
import { useState } from 'react';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import ReactLoading from 'react-loading';
import { FormStyled } from './style';
import { Column } from './style';
import { Row } from './style';

const AdditionalFileInformationModal = ({
  isOpen,
  onClose,
  onSubmitData,
  fileName,
}) => {
  const [data, setData] = useState({
    name: fileName ?? '',
    dueDate: null,
  });
  const [isLoading, setIsLoading] = useState(false);

  const modalAditionalFileInformationRef = useRef(null);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setData({ name: fileName, dueDate: null });
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleOutsideClick = event => {
    if (
      modalAditionalFileInformationRef.current &&
      !modalAditionalFileInformationRef.current.contains(event.target)
    ) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await onSubmitData(data);
      setData({ name: fileName ?? '', dueDate: null });
      onClose();
    } catch (err) {
      console.error('Erro no upload:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return isOpen ? (
    <ModalOverlay onClick={handleOutsideClick}>
      <Modal isOpen={isOpen} onClick={e => e.stopPropagation()}>
        <ModalContent ref={modalAditionalFileInformationRef}>
          <ModalBody>
            <Formik
              initialValues={{
                name: fileName
                  ? fileName
                      .split('.')
                      .slice(0, -1)
                      .join('.')
                  : '',
              }}
              enableReinitialize
            >
              {({ errors, touched }) => (
                <FormStyled>
                  <h1>INFORMAÇÕES ADICIONAIS</h1>
                  <Column>
                    <Row>
                      <div>
                        <strong>NOME</strong>
                        <Field
                          type="text"
                          name="name"
                          required
                          value={
                            data.name
                              ? data.name
                                  .split('.')
                                  .slice(0, -1)
                                  .join('.')
                              : ''
                          }
                          onChange={e =>
                            setData({
                              ...data,
                              name: `${e.target.value}.${fileName
                                .split('.')
                                .pop()}`,
                            })
                          }
                        />
                        {errors.name && touched.name && (
                          <span>{errors.name}</span>
                        )}
                      </div>
                      <div>
                        <strong>DATA DE VENCIMENTO</strong>
                        <Field
                          type="datetime-local"
                          name="dueDate"
                          onChange={e =>
                            setData({ ...data, dueDate: e.target.value })
                          }
                        />
                        {errors.dueDate && touched.dueDate && (
                          <span>{errors.dueDate}</span>
                        )}
                      </div>
                    </Row>
                  </Column>

                  <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <ReactLoading
                        type="spin"
                        color="#011826"
                        height={24}
                        width={24}
                      />
                    ) : (
                      'Salvar'
                    )}
                  </button>
                </FormStyled>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </ModalOverlay>
  ) : null;
};

AdditionalFileInformationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitData: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default AdditionalFileInformationModal;
